import React from 'react';
import App from './App';
import configureStore from './redux/store';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import * as serviceWorker from './serviceWorker';
import {Provider as RollbarProvider, ErrorBoundary} from '@rollbar/react';
import './assets/stylesheets/application.scss';
import {HelmetProvider} from 'react-helmet-async';
import {createRoot} from 'react-dom/client';
import Header from './app/containers/Header';
import {BrowserRouter} from 'react-router-dom';
import {LanguageProvider} from './app/utils/LanguageContext';
import 'react-tooltip/dist/react-tooltip.css';

const {store, persistor} = configureStore();

const rollbarConfig = {
  enabled: process.env.REACT_APP_ENVIRONMENT !== 'development',
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureIp: false,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.REACT_APP_ENVIRONMENT
  }
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<React.StrictMode>
  <RollbarProvider config={rollbarConfig}>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate
          loading={null}
          persistor={persistor}>
          <HelmetProvider>
            <BrowserRouter>
              <LanguageProvider>
                <Header/>
                <App/>
              </LanguageProvider>
            </BrowserRouter>
          </HelmetProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </RollbarProvider>
</React.StrictMode>);

/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();
